<template>
  <div>
    <Head title="បង់ប្រាក់ផ្តាច់" />
    <h1 class="moul flex items-center mb-8 text-2xl">
      <Link class="flex items-center text-indigo-400 hover:text-indigo-600" href="/loans"><BanknotesIcon class="mr-2 w-8 h-8" /> បង់ប្រាក់ផ្តាច់</Link>
      <span class="text-indigo-400 font-medium"><ChevronRightIcon class="w-5 h-5" /></span> សម្រាប់ {{ form.customer_fullname }}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap p-8">
          <text-input disabled v-model="form.customer_id" :error="form.errors.customer_id" class="pb-8 pr-6 w-full lg:w-1/4" label="ID អតិថិជន *" />
          <text-input disabled v-model="form.customer_fullname" :error="form.errors.customer_fullname" class="pb-8 pr-6 w-full lg:w-1/4" label="ឈ្មោះពេញអិតិថិជន *" />
          <text-input v-model="form.loan_id" disabled :error="form.errors.loan_id" class="pb-8 pr-6 w-full lg:w-1/4" label="ID កម្ចី *" />
          <text-input disabled v-model="form.pay_date" :error="form.errors.pay_date" class="pb-8 pr-6 w-full lg:w-1/4" label="កាលបរិច្ឆេទបង់ប្រាក់ *" />
          <text-input v-if="form.can_pay_all" disabled v-model="form.balance" :error="form.errors.balance" class="pb-8 pr-6 w-full lg:w-1/4" label="ប្រាក់ដើមនៅសល់ *" />
          <text-input v-if="form.can_pay_all" disabled v-model="form.principle_amount" :error="form.errors.principle_amount" class="pb-8 pr-6 w-full lg:w-1/4" label="ប្រាក់ដើមត្រូវសង *" />
          <text-input v-if="form.can_pay_all" disabled v-model="form.interest" :error="form.errors.interest" class="pb-8 pr-6 w-full lg:w-1/4" label="ការប្រាក់ត្រូវសង *" />
          <text-input v-if="form.can_pay_all" disabled v-model="form.service_fee" :error="form.errors.service_fee" class="pb-8 pr-6 w-full lg:w-1/4" label="សេវាកម្មប្រ/តិ និងរដ្ឋបាល *" />
          <!-- <text-input v-if="form.can_pay_all && this.totalPaidAmount <= 0" type="number" step="0.01" @keyup="handlePenalty($event)" v-model="form.penalty" :error="form.errors.penalty" class="pb-8 pr-6 w-full lg:w-1/4" label="ពិន័យ" /> -->
          <!-- <text-input v-if="form.can_pay_all && this.totalPaidAmount > 0" disabled type="number" step="0.01" v-model="form.penalty" :error="form.errors.penalty" class="pb-8 pr-6 w-full lg:w-1/4" label="ពិន័យ" /> -->
          <text-input v-if="form.can_pay_all" disabled v-model="form.amount_to_pay" :error="form.errors.amount_to_pay" class="pb-8 pr-6 w-full lg:w-1/4" label="ត្រូវបង់សរុប *" />

          <text-input v-if="form.paid_date" disabled v-model="form.paid_date" :error="form.errors.paid_date" class="pb-8 pr-6 w-full lg:w-1/4" label="កាលបរិច្ឆេទបានបង់ *" />

          <text-input v-if="form.can_pay_all" @keyup="handlePaid($event)" type="number" step="0.01" v-model="form.paid_amount" :error="form.errors.paid_amount" class="pb-8 pr-6 w-full lg:w-1/4" label="ប្រាក់ដែលនឹងត្រូវបង់ *" />
          <!-- <text-input v-if="form.can_pay_all" disabled v-model="form.amount_due" :error="form.errors.amount_due" class="pb-8 pr-6 w-full lg:w-1/4" label="នៅសល់ *" /> -->
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">ធ្វើការបង់ប្រាក់</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import axios from 'axios'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import { BanknotesIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'
import { formattedDate, isDateLaterThanToday, formatTwoDigits, formatNumber } from '@/helper'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    BanknotesIcon,
    ChevronRightIcon,
  },
  layout: Layout,
  remember: 'form',
  props: {
    payment: Object,
    loan: Object,
    customer: Object,
    paid_amount: Number,
  },
  data() {
    return {
      amount_to_pay: 0,
      paids: [],
      form: this.$inertia.form({
        customer_id: this.customer.customer_id,
        customer_fullname: this.customer.first_name + ' ' + this.customer.last_name,
        loan_id: this.loan.loan_id,
        loan_primary_id: this.loan.id,
        pay_id: this.payment.id,
        pay_date: formattedDate(this.payment.pay_date),
        can_pay_all: 1, //this.payment.can_pay_all,
        balance: this.payment.balance - this.paid_amount,
        principle_amount: this.payment.balance - this.paid_amount,
        interest: this.payment.interest,
        service_fee: this.payment.service_fee,
        amount_to_pay: formatTwoDigits(parseFloat(this.payment.balance - this.paid_amount) + parseFloat(this.payment.interest) + parseFloat(this.payment.service_fee)),
        paid_amount: null,
        paid_date: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/repays/save_payall')
    },
    formattedDate,
    formatNumber,
  },
}
</script>
